module.exports = __webpack_public_path__ + "img/shouji.49e141c8.jpg";